module.exports = __webpack_public_path__ + "img/restaurant-drinks.bc2391fb.svg";